import { render, staticRenderFns } from "./MapMunicipalityList.vue?vue&type=template&id=6f13f318&scoped=true&"
import script from "./MapMunicipalityList.vue?vue&type=script&lang=js&"
export * from "./MapMunicipalityList.vue?vue&type=script&lang=js&"
import style0 from "./MapMunicipalityList.vue?vue&type=style&index=0&id=6f13f318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13f318",
  null
  
)

export default component.exports